import { Fragment, memo, useState, useEffect, useRef } from 'react';
import React from 'react';
import { faReply, faSync, faPrint, faPlus, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useSessionStorage } from '../../../components/Util/Hooks/useSessionStorage.jsx';
import ModalSpinner from '../../../components/UI/modalSpinner/modalSpinner.jsx';
import ModalSeguridad from '../../Seguridad/ModalSeguridad.jsx';
import optSeg from '../../../components/Util/seg-menu-opciones.js';
import ListaCentroCostoInt from './listaCentroCostoInt.jsx';
import { withRouter, useHistory } from 'react-router-dom';
import { CentrosCostos_Listar_Request, CentrosCostos_Modificar_Usuario_Request, CentrosCostos_Eliminar_Request, DetalleCentroCostos_Eliminar_Request} from '../../../request/MantenimientosRequest.jsx';
import { SiteRutas } from '../../../request/RutasConfig.jsx';
import Config from '../../../components/Util/constantes.js';
import { Obtener_MenuOpciones_Lista_Request, Obtener_MenuNombre_Request } from "../../../request/MenuRequest.jsx"
import Swal from 'sweetalert2';
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion.jsx';

export function listaCentroCosto() {

    let historyMenu = useHistory();

    const mounted = useRef();
    const [listaDatos, setListaDatos] = useState([]);
    const [menuId, setMenuId] = useState(0);
    const [menuOpciones, setMenuOpciones] = useState([]);
    const [opcionValidar, setOpcionValidar] = useState(0);
    const [datosEmpresa, setDatosEmpresa] = useState(undefined);
    const [Pais, setPais] = useSessionStorage('paisCON');
    const [token, setToken] = useSessionStorage('tokenCON', '');
    const [usuario, setUsuario] = useSessionStorage('usuarioCON');
    const [empresa, setEmpresa] = useSessionStorage('empresaCON', 0);
    const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON');
    const [opcionValidarNombre, setOpcionValidarNombre] = useState('');
    const [showModalSeguridad, setShowModalSeguridad] = useState(false);
    const [selectedCC, setSelectedCC] = useState(0);
    const [selectedCCN, setSelectedCCN] = useState(0);

    const [spinnerTipo, setSpinnerTipo] = useState(1);
    const [spinnerLabel, setSpinnerLabel] = useState('');
    const [spinnerModal, setSpinnerModal] = useState(undefined);

    const botones = [
        {
            name: "btnHomeC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => volverAtras(),
            leyenda: "",
            iclase: faReply,
            tooltip: "Volver"
        },
        {
            name: "btnNuevoC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => AgregarNuevoCC(),
            leyenda: "",
            iclase: faPlus,
            tooltip: "Nuevo"
        },
        {
            name: "btnModificarC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => ModificarCC(),
            leyenda: "",
            iclase: faPen,
            tooltip: "Modificar"
        },
        {
            name: "btnBorrarC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => validaEliminarCentroCosto(),
            leyenda: "",
            iclase: faTrash,
            tooltip: "Borrar"
        },
        {
            name: "btnImprimirC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => { },
            leyenda: "",
            iclase: faPrint,
            tooltip: "Imprimir"
        },
    ];

    const validaSeleccionado = () => {

        if (selectedCC > 0) {
            return true;
        } else {
            return false;
        }

    };

    const columnas = [
        {
            dataField: 'ID',
            text: 'ID',
            csvText: 'ID',
            sort: true,
        },
        {
            dataField: 'Nombre',
            text: 'Nombre',
            csvText: 'Nombre',
            sort: true,
        }
    ];

    const selectRow = {
        mode: 'radio', clickToSelect: true, hideSelectColumn: true, onSelect: (row, isSelect, rowIndex, e) => {
            onRowSelect(row);
        }, clickToEdit: true, bgColor: '#d73220', style: { color: '#ffffff' }
    };


    useEffect(() => {

        if (!mounted.current) {
            const carga = async () => {
                await cargarDatos()
            }
            carga();

            mounted.current = true;
        }

    }, []);

    const cargarDatos = async () => {

        let spinnerLabel = "Cargando Datos...";
        spinnerModalMostrar(true, spinnerLabel, 3);

        await cargarSeguridad();
        await cargaCC();


        spinnerModalMostrar(false, '', 3);

    }

    const cargaCC = async () => {
        let arrayDatos = [];

        const responseCentrosCosto = await CentrosCostos_Listar_Request(token, empresa, 0, 0, 0);

        if (responseCentrosCosto.Exitoso) {

            if (responseCentrosCosto.Datos.length > 1) {
                arrayDatos = responseCentrosCosto.Datos;
            } else {

                if (responseCentrosCosto.Datos[0].ID > 0 && responseCentrosCosto.Datos[0].Empresa > 0) {
                    arrayDatos = responseCentrosCosto.Datos;
                }

            }

        } else {
            Notificacion.error("Sucedió un error al consultar los centros de costo.");
            volverAtras();
            return;
        }

        setListaDatos(arrayDatos);
    }

    const cargarSeguridad = async () => {
        const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.CentrosdeCosto.value);
        let _menuId = 0
        if (_MenuNomb.ID != undefined) {
            _menuId = _MenuNomb.ID;
        }
        const _UsuarioS = usuarioS;
        let _menuOpciones = null;
        if (_menuId > 0) {
            _menuOpciones = await cargarMenuOpciones(Config.Modulo, _UsuarioS, _menuId);
        }

        setMenuId(_menuId), setMenuOpciones(_menuOpciones)
    }

    const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
        try {
            let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
            if (listMO.Exitoso === false) {
                return null;
            }
            return listMO.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuOpciones.`);
        }
    }

    const cargarMenuNombre = async (pModulo, pMenuNombre) => {
        try {
            let listMON = await Obtener_MenuNombre_Request(token, pModulo, pMenuNombre);
            if (listMON.Exitoso == false) {
                return null;
            }
            return listMON.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuNombre.`);
        }
    }

    const volverAtras = () => {
        historyMenu.push(SiteRutas.Asientos);
    }

    const onActionResultModal = (pValido) => {
        if (pValido) {
            let _OpcionNom = opcionValidarNombre;
            setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
            const _optSegopt = optSeg.TOpciones_Menu;
            switch (_OpcionNom) {
                case _optSegopt.Eliminar.value:
                    confirmEliminarCentro();
                    break;
                default:
                    break;
            }
        }
    }

    const handleCerrarModal = () => setShowModalSeguridad(false);

    const validarMenuOpcion = (pOpcion) => {
        let validar = false;
        let _menuOpciones = menuOpciones;

        let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);

        if (resultado.length > 0) {
            if (resultado[0].Opcion_Validar) {
                setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
                validar = true;
            }
        } else {
            setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
            validar = true;
        }
        return validar;
    };

    const validaEliminarCentroCosto = async () => {

        if (validaSeleccionado()) {

            const optSegopt = optSeg.TOpciones_Menu;
            const _value = optSegopt.Eliminar.value;

            let validar = validarMenuOpcion(_value);

            if (!validar) {
                confirmEliminarCentro();
            }

        } else {
            Notificacion.warning("Debe seleccionar un registro.");
        }
    }

    const confirmEliminarCentro = async () => {

        let resultado = false;
        Swal.fire({
            title: 'Atención',
            html: '<h4>¿Está seguro de querer borrar el Centro de Costos "' + selectedCCN + '"?</h4>',
            showCancelButton: true,
            confirmButtonColor: '#10a599',
            cancelButtonColor: '#d33',
            confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
            cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                resultado = true;
                finalizaEliminarCentroCostos();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                resultado = false;
            }
        });

    }

    const generarItem = () => {

        return {
            ID: "",
            Usuario_Modifica: ""
        };

    };

    const finalizaEliminarCentroCostos = async () => {

        const spinnerLabel = "Eliminando Datos...";
        spinnerModalMostrar(true, spinnerLabel, 3);

        let item = generarItem();

        item.ID = selectedCC;
        item.Usuario_Modifica = usuario;

        const eliminaDetalle = await DetalleCentroCostos_Eliminar_Request(token, item.ID, 0);

        if (eliminaDetalle.Exitoso) {

            const modificaUsuario = await CentrosCostos_Modificar_Usuario_Request(token, item);

            if (modificaUsuario.Exitoso) {
    
                const eliminaCentroCosto = await CentrosCostos_Eliminar_Request(token, item.ID);
    
                if (eliminaCentroCosto.Exitoso) {
    
                    await cargaCC();
                    Notificacion.success("Se eliminó el centro de costos correctamente.");
                    spinnerModalMostrar(false, '', 3);
    
                } else {
                    Notificacion.error("Sucedió un error al eliminar el centro de costo.");
                }
    
            } else {
                Notificacion.error("Sucedió un error al iniciar el proceso de eliminación del centro de costo.");
                volverAtras();
                return;
            }

        } else {
            Notificacion.error("Sucedió un error al eliminar el detalle del centro de costos.");
            volverAtras();
            return;
        }

    };

    const rowEvents = {
        onDoubleClick: (e, row, rowIndex) => {
            ModificarCC();
        }
    };

    const spinnerModalMostrar = (pSpinnerModal, pSpinnerLabel, pSpinnerTipo) => {
        setSpinnerModal(pSpinnerModal);
        setSpinnerLabel(pSpinnerLabel);
        setSpinnerTipo(pSpinnerTipo);
    }

    const onRowSelect = (row) => {
        setSelectedCC(row.ID);
        setSelectedCCN(row.Nombre);
    }

    const AgregarNuevoCC = () => {
        historyMenu.push(SiteRutas.MantCentrosCostos+"/0");
    }

    const ModificarCC = () => {
        if(validaSeleccionado()){
            historyMenu.push(SiteRutas.MantCentrosCostos+"/"+selectedCC);
        }else{
            Notificacion.warning("Debe seleccionar un registro.");
        }
    }

    return (
        <Fragment>

            <ListaCentroCostoInt
                titulo={"Centros de Costos"}
                botones={botones}
                selectRow={selectRow}
                columnas={columnas}
                Datos={listaDatos}
                rowEvents={rowEvents}
            />

            <ModalSpinner
                selectedModal={spinnerModal}
                contentLabel={'spinnerModalProgress'}
                label={spinnerLabel}
                tipoSpinner={spinnerTipo}
            />

            <ModalSeguridad
                modalTitle={'Requiere Permisos'}
                menuId={menuId}
                opcionId={opcionValidar}
                show={showModalSeguridad}
                onActionResult={onActionResultModal}
                onHide={handleCerrarModal}
            />

        </Fragment>
    );
};
export default withRouter(memo(listaCentroCosto))